export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="overline text-[#BA5A3A]">Rental Terms — Northern Territory</div>
      <h1 className="text-4xl md:text-5xl font-black tracking-tighter mt-2">Rental Agreement (Template)</h1>
      <p className="mt-4 text-sm text-[#595959]"><strong>Note:</strong> This document is a plain-English preview. Full NT-compliant agreement will be provided as a PDF for e-signature at booking. Reviewed by an NT solicitor before first hire.</p>
      <div className="prose mt-8 space-y-6 text-[15px] leading-relaxed">
        <Section n="1" t="Permitted use area">
          Hilux: Darwin region, Litchfield NP, Kakadu NP (sealed sections), Berry Springs, Adelaide River — sealed and graded unsealed roads only. Kluger: sealed roads only. No Cape York, no Gibb River Road, no beach driving, no river crossings, no interstate without written approval.
        </Section>
        <Section n="2" t="Prohibited use">
          No racing, driving instruction, subletting, exceeding seatbelt count, transporting hazardous goods, towing without approval, or driving under the influence.
        </Section>
        <Section n="3" t="Damage & insurance excess">
          Damage is charged to the renter up to the insurance excess, which equals the bond: Hilux A$5,000 (A$500 with excess reduction, A$65/day); Kluger A$3,000 (A$500 with excess reduction, A$35/day). Single-vehicle rollover, underbody, tyre and windscreen damage is generally not covered under standard cover — renter is liable. Excess reduction includes one windscreen and two tyres.
        </Section>
        <Section n="4" t="Off-road (Hilux)">
          Light off-road on graded tracks only. No water crossings deeper than the door sill. Renter accepts full liability for off-road damage. Vehicle is GPS-tracked (disclosed).
        </Section>
        <Section n="5" t="Fuel, cleaning, keys">
          Return the vehicle full and clean. Refuelling fee = fuel cost + A$50 service charge. Excessive cleaning fee A$150. Lost key fee A$450.
        </Section>
        <Section n="6" t="Late return, traffic fines, recovery">
          Late return A$50/hr up to a daily rate. Traffic and parking fines are on-charged with A$30 admin fee per infringement. Recovery/tow costs due to renter misuse are payable by the renter.
        </Section>
        <Section n="7" t="Cancellation">
          &gt;14 days before pickup: full refund less A$50 admin. 7–14 days: 50% refund. &lt;7 days: forfeit deposit.
        </Section>
        <Section n="8" t="Governing law">
          Northern Territory of Australia.
        </Section>
      </div>
    </div>
  );
}
function Section({ n, t, children }) {
  return (
    <div>
      <h3 className="font-black text-lg"><span className="text-[#BA5A3A]">§{n}.</span> {t}</h3>
      <p className="mt-2 text-[#1C1C1C]">{children}</p>
    </div>
  );
}
